import { createReducer } from 'src/helpers/reducer';
import { ISendRequestParams } from '@dash/actions';
import actionsTypes from './actionTypes';
import {
  IFetchActiveSkillsResponsePayload,
  IFetchDeniedSkillsResponsePayload,
  IFetchPendingSkillsResponsePayload,
  ISkillState,
} from './types';

const initState: ISkillState = {
  isLoading: false,
  isActiveSkillsLoading: false,
  isPendingSkillsLoading: false,
  isDeniedSillsLoading: false,
  activeSkills: undefined,
  pendingSkills: undefined,
  deniedSkills: undefined,
  isMarkEligibleLoading: false,
  pendingSkillsActions: undefined,
};

function onProcessActionRequest(state: ISkillState, { payload }: { payload: ISendRequestParams }) {
  const { key } = payload;

  if (['mark_as_ineligible', 'mark_as_eligible'].includes(key)) {
    return {
      ...state,
      isMarkEligibleLoading: true,
    };
  }

  return {
    ...state,
    isLoading: true,
  };
}

function onProcessActionSuccess(state: ISkillState) {
  return {
    ...state,
    isLoading: false,
    isMarkEligibleLoading: false,
  };
}

function onProcessActionError(state: ISkillState) {
  return {
    ...state,
    isLoading: false,
    isMarkEligibleLoading: false,
  };
}

function onLoadActiveSkillsRequest(state: ISkillState) {
  return {
    ...state,
    isActiveSkillsLoading: true,
  };
}

function onLoadActiveSkillsSuccess(state: ISkillState, { payload }: { payload: IFetchActiveSkillsResponsePayload }) {
  const { activeSkills } = payload;

  return {
    ...state,
    isActiveSkillsLoading: false,
    activeSkills,
  };
}

function onLoadActiveSkillsError(state: ISkillState) {
  return {
    ...state,
    isActiveSkillsLoading: false,
  };
}

function onLoadPendingSkillsRequest(state: ISkillState) {
  return {
    ...state,
    isPendingSkillsLoading: true,
  };
}

function onLoadPendingSkillsSuccess(state: ISkillState, { payload }: { payload: IFetchPendingSkillsResponsePayload }) {
  const { pendingSkills, pendingSkillsActions } = payload;

  return {
    ...state,
    isPendingSkillsLoading: false,
    pendingSkills,
    pendingSkillsActions,
  };
}

function onLoadPendingSkillsError(state: ISkillState) {
  return {
    ...state,
    isPendingSkillsLoading: false,
  };
}

function onLoadDeniedSkillsRequest(state: ISkillState) {
  return {
    ...state,
    isDeniedSillsLoading: true,
  };
}

function onLoadDeniedSkillsSuccess(state: ISkillState, { payload }: { payload: IFetchDeniedSkillsResponsePayload }) {
  const { deniedSkills } = payload;

  return {
    ...state,
    isDeniedSillsLoading: false,
    deniedSkills,
  };
}

function onLoadDeniedSkillsError(state: ISkillState) {
  return {
    ...state,
    isDeniedSillsLoading: false,
  };
}

export default createReducer(initState, {
  [actionsTypes.PROCESS_ACTION_REQUEST]: onProcessActionRequest,
  [actionsTypes.PROCESS_ACTION_SUCCESS]: onProcessActionSuccess,
  [actionsTypes.PROCESS_ACTION_ERROR]: onProcessActionError,
  [actionsTypes.LOAD_ACTIVE_SKILL_REQUEST]: onLoadActiveSkillsRequest,
  [actionsTypes.LOAD_ACTIVE_SKILL_SUCCESS]: onLoadActiveSkillsSuccess,
  [actionsTypes.LOAD_ACTIVE_SKILL_ERROR]: onLoadActiveSkillsError,
  [actionsTypes.LOAD_PENDING_SKILL_REQUEST]: onLoadPendingSkillsRequest,
  [actionsTypes.LOAD_PENDING_SKILL_SUCCESS]: onLoadPendingSkillsSuccess,
  [actionsTypes.LOAD_PENDING_SKILL_ERROR]: onLoadPendingSkillsError,
  [actionsTypes.LOAD_DENIED_SKILL_REQUEST]: onLoadDeniedSkillsRequest,
  [actionsTypes.LOAD_DENIED_SKILL_SUCCESS]: onLoadDeniedSkillsSuccess,
  [actionsTypes.LOAD_DENIED_SKILL_ERROR]: onLoadDeniedSkillsError,
});
